import { Middleware, UnknownAction } from 'redux'
import { updateUserSettings } from '@disco/state-management/actions/UserActions'
import { setColumnVisibility } from '@disco/state-management/reducers/search-page'
import { getUserSettings } from '@disco/state-management/selectors/user'
import { PRELOAD_DATA_ON_LOGIN } from '@disco/constants/ActionTypes'

export const SEARCH_TABLE_VISIBILITY_KEY = 'search_column_visibility'

/**
 * A middleware that handles search preferences by:
 * 1. Loading saved user preferences after data preload (overrides defaults set by reducer)
 * 2. Saving column visibility changes to user settings
 */
const searchPreferencesSync: Middleware<object, any> = store => {
  // On first load, we need to load the settings from the server and set them in the redux store
  // but we don't want to trigger an update at the same time, as it is not necessary
  let isLoadingFromSettings = false

  return next => (action: UnknownAction) => {
    // Process the action first (standard middleware pattern)
    const result = next(action)

    // Load saved user preferences when data is preloaded
    if (action.type === PRELOAD_DATA_ON_LOGIN) {
      const state = store.getState()
      const userSettings = getUserSettings(state)

      if (userSettings?.[SEARCH_TABLE_VISIBILITY_KEY]) {
        isLoadingFromSettings = true
        try {
          store.dispatch(
            setColumnVisibility(userSettings[SEARCH_TABLE_VISIBILITY_KEY]),
          )
        } finally {
          isLoadingFromSettings = false
        }
      }
    }

    // Save changes to user preferences when column visibility changes
    if (setColumnVisibility.match(action) && !isLoadingFromSettings) {
      const visibility = action.payload

      store.dispatch(
        updateUserSettings({
          settings: {
            [SEARCH_TABLE_VISIBILITY_KEY]: visibility,
          },
        }),
      )
    }

    return result
  }
}

export default searchPreferencesSync
